/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CenterUpdateIF } from './CenterUpdateIF';
import {
    CenterUpdateIFFromJSON,
    CenterUpdateIFFromJSONTyped,
    CenterUpdateIFToJSON,
    CenterUpdateIFToJSONTyped,
} from './CenterUpdateIF';

/**
 * 
 * @export
 * @interface CenterUpdate
 */
export interface CenterUpdate {
    /**
     * 
     * @type {Array<CenterUpdateIF>}
     * @memberof CenterUpdate
     */
    body: Array<CenterUpdateIF>;
}

/**
 * Check if a given object implements the CenterUpdate interface.
 */
export function instanceOfCenterUpdate(value: object): value is CenterUpdate {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function CenterUpdateFromJSON(json: any): CenterUpdate {
    return CenterUpdateFromJSONTyped(json, false);
}

export function CenterUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CenterUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'body': ((json['body'] as Array<any>).map(CenterUpdateIFFromJSON)),
    };
}

export function CenterUpdateToJSON(json: any): CenterUpdate {
    return CenterUpdateToJSONTyped(json, false);
}

export function CenterUpdateToJSONTyped(value?: CenterUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': ((value['body'] as Array<any>).map(CenterUpdateIFToJSON)),
    };
}

